<div *ngIf="isOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div
    class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[90vh] overflow-hidden animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 flex items-center justify-center">
          <span class="material-icons">login</span>
        </div>
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">ทำรายการเข้า</h3>
          <p class="text-xs text-slate-400">Force Enter Transaction</p>
        </div>
      </div>
      <button type="button" (click)="close()" [disabled]="isSubmitting"
        class="w-8 h-8 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 space-y-4 overflow-y-auto custom-scrollbar" (click)="closeDropdowns()">
      <div>
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
          ทะเบียน <span class="text-rose-500">*</span>
        </label>
        <div class="relative h-[46px] flex items-center rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
          <span class="material-icons text-slate-400 absolute left-3 text-lg">directions_car</span>
          <input type="text" [(ngModel)]="licensePlate" placeholder="เช่น 1กก1234"
            class="w-full h-full pl-11 pr-3 bg-transparent rounded-xl text-sm font-bold text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200"
            [disabled]="isSubmitting" />
        </div>
      </div>

      <div class="relative">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
          ประตูเข้า <span class="text-rose-500">*</span>
        </label>
        <div class="relative h-[46px] flex items-center rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
          <span class="material-icons text-slate-400 absolute left-3 text-lg">door_front</span>
          <input type="text" [(ngModel)]="gateSearchText"
            (focus)="isGateDropdownOpen = true; $event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (blur)="closeDropdowns()"
            placeholder="พิมพ์ค้นหาประตูเข้า..."
            class="w-full h-full pl-11 pr-10 bg-transparent rounded-xl text-sm font-bold text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200"
            [disabled]="isSubmitting" />
          <span class="material-icons text-slate-400 absolute right-3 text-sm pointer-events-none"
            [class.rotate-180]="isGateDropdownOpen">expand_more</span>
        </div>
        <div *ngIf="isGateDropdownOpen" (mousedown)="$event.preventDefault()"
          class="absolute z-40 left-0 right-0 mt-1 max-h-48 overflow-y-auto custom-scrollbar bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1">
          <div *ngIf="filteredGates.length === 0" class="px-3 py-2 text-xs text-slate-400 text-center font-bold">ไม่พบประตู</div>
          <button type="button" *ngFor="let g of filteredGates" (click)="selectGate(g)"
            class="w-full text-left px-3 py-2 text-sm font-bold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600">
            {{ g.name }}
          </button>
        </div>
      </div>

      <div class="relative">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
          ประเภทรถ <span class="text-rose-500">*</span>
        </label>
        <div class="relative h-[46px] flex items-center rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
          <span class="material-icons text-slate-400 absolute left-3 text-lg">two_wheeler</span>
          <input type="text" [(ngModel)]="vehicleTypeSearchText"
            (focus)="isVehicleTypeDropdownOpen = true; $event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (blur)="closeDropdowns()"
            placeholder="พิมพ์ค้นหาประเภทรถ..."
            class="w-full h-full pl-11 pr-10 bg-transparent rounded-xl text-sm font-bold text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200"
            [disabled]="isSubmitting" />
          <span class="material-icons text-slate-400 absolute right-3 text-sm pointer-events-none"
            [class.rotate-180]="isVehicleTypeDropdownOpen">expand_more</span>
        </div>
        <div *ngIf="isVehicleTypeDropdownOpen" (mousedown)="$event.preventDefault()"
          class="absolute z-40 left-0 right-0 mt-1 max-h-48 overflow-y-auto custom-scrollbar bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1">
          <div *ngIf="filteredVehicleTypes.length === 0" class="px-3 py-2 text-xs text-slate-400 text-center font-bold">ไม่พบประเภท</div>
          <button type="button" *ngFor="let v of filteredVehicleTypes" (click)="selectVehicleType(v)"
            class="w-full text-left px-3 py-2 text-sm font-bold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600">
            {{ v.typeName }}
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
            วันเข้า <span class="text-rose-500">*</span>
          </label>
          <div class="relative h-[46px] flex items-center rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
            <span class="material-icons text-slate-400 absolute left-3 text-lg pointer-events-none z-10">event</span>
            <input type="text" [matDatepicker]="comeInPicker" [(ngModel)]="comeInDate"
              placeholder="dd/mm/yyyy" readonly (click)="comeInPicker.open()"
              class="w-full h-full pl-11 pr-3 bg-transparent rounded-xl text-sm font-bold text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer"
              [disabled]="isSubmitting" />
            <mat-datepicker #comeInPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
          </div>
        </div>
        <div>
          <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
            เวลาเข้า (24 ชม.) <span class="text-rose-500">*</span>
          </label>
          <div class="relative h-[46px] flex items-center rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
            <span class="material-icons text-slate-400 absolute left-3 text-lg pointer-events-none">schedule</span>
            <input type="text" [(ngModel)]="comeInTime"
              (input)="onComeInTimeInput($event)"
              (blur)="normalizeComeInTime()"
              inputmode="numeric" maxlength="5" placeholder="HH:mm (24 ชม.)"
              class="w-full h-full pl-11 pr-3 bg-transparent rounded-xl text-sm font-bold text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200"
              [disabled]="isSubmitting" />
          </div>
        </div>
      </div>

      <div>
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
          เหตุผล <span class="text-rose-500">*</span>
        </label>
        <textarea [(ngModel)]="reason" rows="3" placeholder="ระบุเหตุผลทำรายการเข้า..."
          class="w-full px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none"
          [disabled]="isSubmitting"></textarea>
      </div>

      <div>
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
          แนบรูปทางเข้า <span class="font-medium normal-case tracking-normal text-slate-400">(ไม่บังคับ)</span>
        </label>
        <div class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 p-4">
          <div *ngIf="!imagePreviewUrl" class="flex flex-col sm:flex-row sm:items-center gap-3">
            <label
              class="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-bold text-slate-600 dark:text-slate-300 cursor-pointer hover:border-amber-300 hover:text-amber-600 transition-colors"
              [class.opacity-50]="isSubmitting"
              [class.pointer-events-none]="isSubmitting">
              <span class="material-icons text-lg">add_photo_alternate</span>
              เลือกรูป
              <input type="file" accept="image/*" class="hidden" (change)="onImageSelected($event)" [disabled]="isSubmitting" />
            </label>
            <span class="text-xs text-slate-400">JPG / PNG ขนาดไม่เกิน 5MB</span>
          </div>

          <div *ngIf="imagePreviewUrl" class="flex items-start gap-3">
            <div class="relative w-28 h-20 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-900 shrink-0">
              <img [src]="imagePreviewUrl" alt="preview" class="w-full h-full object-cover" />
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200 truncate">{{ imageFileName || 'รูปที่แนบ' }}</p>
              <p class="text-[11px] text-slate-400 mt-0.5">จะอัปโหลดเมื่อยืนยันทำรายการเข้า</p>
              <div class="flex flex-wrap gap-2 mt-2">
                <label
                  class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-xs font-bold text-slate-600 cursor-pointer hover:text-amber-600"
                  [class.opacity-50]="isSubmitting"
                  [class.pointer-events-none]="isSubmitting">
                  เปลี่ยนรูป
                  <input type="file" accept="image/*" class="hidden" (change)="onImageSelected($event)" [disabled]="isSubmitting" />
                </label>
                <button type="button" (click)="clearImage()"
                  class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-bold text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20"
                  [disabled]="isSubmitting">ลบรูป</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <label class="flex items-center gap-2 cursor-pointer select-none">
        <input type="checkbox" [(ngModel)]="openGate"
          class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400"
          [disabled]="isSubmitting" />
        <span class="text-sm font-bold text-slate-600 dark:text-slate-300">เปิดไม้กั้น (Open Gate)</span>
      </label>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3 bg-slate-50/80 dark:bg-slate-900/50">
      <button type="button" (click)="close()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-sm text-slate-600 dark:text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isSubmitting">ยกเลิก</button>
      <button type="button" (click)="askSubmit()"
        class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold text-sm disabled:opacity-50 flex items-center gap-2 disabled:cursor-not-allowed"
        [disabled]="isSubmitting">
        ยืนยันทำรายการเข้า
      </button>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="showConfirm"
  title="ยืนยันทำรายการเข้า?"
  [message]="confirmMessage"
  confirmLabel="ใช่, ทำรายการ"
  cancelLabel="ไม่"
  variant="warning"
  icon="login"
  [showIrreversibleNote]="false"
  [loading]="isSubmitting"
  (confirm)="confirmSubmit()"
  (cancel)="closeConfirm()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isSubmitting"></app-pss-loading>
